module.exports = __webpack_public_path__ + "img/trash.edf283a2.svg";